import script from "./TaskCardDoneList.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskCardDoneList.vue?vue&type=script&setup=true&lang=js"

import "./TaskCardDoneList.vue?vue&type=style&index=0&id=c45e5ca6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c45e5ca6"]])

export default __exports__